import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Add, Description } from "@material-ui/icons";
import CardTable from "components/CardTable/CardTable";
import RegularButton from "components/CustomButtons/Button";
import { ModalV2 } from "components/Modal/ModalV2";
import { useSearch } from "hooks/useSearch";
import { configTable } from "./config";
import { useTableSgcConfigurationsConfig } from "./hooks";
import { SgcConfigurationsInputs } from "./SgcConfigurationsInputs";
import { FormSgcConfiguration } from "./FormSgcConfigurationEdit";
import {
  resetSgcConfigurationSelected,
  addSgcConfigurationsMode
} from "redux/actions/sgcConfigurations/sgcConfigurationsAction";

export default function SgcConfigurations() {
  const { buildCompLoadings } = useSearch();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [columnsData, setColumnsData] = useState([]);
  const { stations } = useSelector(({ companies }) => companies);
  const { sgcConfigurations, config, addMode, deleteMode } = useSelector(({ sgcConfigurations }) => sgcConfigurations);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { page, pageSize, sorted, filtered } = config;
  const {
    handleFilter,
    handlePage,
    handlePageSize,
    handleSort,
  } = useTableSgcConfigurationsConfig();

  const handleClose = () => {
    dispatch(resetSgcConfigurationSelected());
    setOpen(false);
  };

  const handleOpenAdd = () => {
    dispatch(addSgcConfigurationsMode());
    setOpen(true);
  };

  useEffect(() => buildCompLoadings(["loadingSgcConfigurations"]), []);

  useEffect(() => {
    if (sgcConfigurations.length) setColumnsData(
      sgcConfigurations.map(config => ({
        ...config,
        station: stations[config?.idStation]?.name,
        modal: setOpen
      }))
    );
    // eslint-disable-next-line
  }, [sgcConfigurations, isLoadingComp?.loadingSgcConfigurations]);

  return (
    <>
      <CardTable
        data={columnsData}
        columns={configTable}
        hasHeader
        blockBtn
        title={"Configuraciones de SGC"}
        icon={<Description />}
        page={page}
        pageSize={pageSize}
        sorted={sorted}
        filtered={filtered}
        onFilteredChange={handleFilter}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePage}
        onSortedChange={handleSort}
        isLoading={isLoadingComp?.loadingSgcConfigurations}
        tableContent={<SgcConfigurationsInputs />}
        hasControl
        controls={
          <RegularButton
            round
            justIcon
            color="info"
            tooltip="Crear Configuración"
            onClick={handleOpenAdd}
            style={{ margin: 10 }}
          >
            <Add style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      <ModalV2
        open={open}
        title={
          addMode
            ? "Agregar configuración"
            : deleteMode ? "¿Estás seguro de eliminar esta configuración?"
            : "Modificar configuración"
        }
        toRight
        onClose={handleClose}
      >
        <FormSgcConfiguration handleClose={handleClose} />
      </ModalV2>
    </>
  );
}
